import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedData } from '../../shared/sharedData';
import { Configuration } from '../../shared/services/configuration';
import { HttpClientCustom } from '../../shared/services/http.client';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'underscore';
import { Auth } from '../../shared/services/auth';
import { window } from 'rxjs/operator/window';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';

@Component({
    selector: 'employeeTransfer',
    templateUrl: 'employeeTransfer.html'
})
export class EmployeeTransferComponent {
    public confirmationMessage: any;
    public oldOrgId: any;
    public employeeId: any;
    public type: any;
    public _baseUrl: any;
    public allScoreCardData: any = [];
    public employeeData: any;
    public finalEndDate: any;
    public tempArray: any = [];
    public finalPayload: any = [];
    public modelArray: any = {};
    constructor(
        public route: ActivatedRoute,
        public activeModal: NgbActiveModal,
        public _global: Configuration,
        public translate: TranslateService,
        public _http: HttpClientCustom,
        public _auth: Auth,
        public _share: SharedData,
        public _toaster: ToasterComponent,
        public vcr: ViewContainerRef
    ) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this.allScoreCardData = this._share.getMapValues('scoreCardData');
        this.employeeData = this._share.getMapValues('employeeData');
        this.formatPayload();
    }
    public formatPayload() {
        let that = this;
        let arr: any = [];
        _.each(that.allScoreCardData, function (key, val) {
            let payload = { scorecardId: null, endDate: null, orgUnitId: null };
            payload.scorecardId = key.scorecardId;
            payload.endDate = null;
            payload.orgUnitId = that.employeeData.orgId;
            arr.push(payload);
        });
        that.tempArray = arr;
    }

    public confirm(option) {
        try {
            let that = this;
            if (that.validatePayload(option)) {
                that.transferEmployee(option);
            }
        } catch (e) {
            console.log('saveEmployee error caught', e);
        }
    }

    public transferEmployee(option) {
        let that = this;
        let payload: any;
        if (option == 'Transfer') {
            payload = that.finalPayload;
        } else {
            payload = this.tempArray;
        }
        let url = this._baseUrl + 'v1/webAdmin/employee/fireEmployeeTransfer';
        that._http.post(url, that.finalPayload).subscribe(results => {
            if (results.success && results.errorMessages.length == 0) {
                setTimeout(() => { this.activeModal.close('confirmed'); }, 1000);
                this.translate.get(results.message).subscribe((msg)=>{
                    this._toaster.showSuccess(msg);
                }) 
            } else {
                this.translate.get(results.message).subscribe((msg)=>{
                    this._toaster.showSuccess(msg);
                })
            }
        });
    }
    public checkSelected(i, e) {
        if (e.target.checked) {
            this.finalPayload.push(this.tempArray[i]);
        } else {
            if (this.finalPayload.length == 1) {
                this.finalPayload = [];
            } else {
                this.finalPayload.splice(i, 1);
            }
        }
    }
    public programEndDateChanged(e, i) {
        this.tempArray[i].endDate = e.year + '-' + e.month + '-' + e.day;
    }

    public validatePayload(option) {
        let that = this;
        let flag = true;
        if (option == 'Transfer') {
            if (that.finalPayload.length > 0) {
                for (let i = 0; i < that.finalPayload.length; i++) {
                    if (that.finalPayload[i].endDate == null) {
                        flag = false;
                        that.translate.get('selectEndDate').subscribe((msg) => {
                            that._toaster.showError(msg);
                        });
                        break;
                    }
                }
            } else {
                that.translate.get('programToTransfer').subscribe((msg) => {
                    that._toaster.showError(msg);
                });
                flag = false;
            }
            return flag;
        } else {
            if (that.tempArray.length > 0) {
                _.each(that.tempArray, function (key, val) {
                    key.endDate = null
                });
            }
            return flag;
        }
    }
    public getFormatedDate(formatDate) {
        if (formatDate == undefined) {
            return;
        }
        let changeDate = formatDate.split('-');
        let formatedDate = {
            year: +changeDate[0],
            month: +changeDate[1],
            day: +changeDate[2]
        };
        return formatedDate;
    }


}



// WEBPACK FOOTER //
// ./src/app/employee/employeeTransfer/employeeTransfer.ts